<template>
    <div class="w-full h-full flex flex-col">
        <div
            v-if="isLoading"
            class="h-10 flex items-center px-2 text-sm text-theme-muted"
        >
            Cargando...
        </div>
        <custom-simple-select
            v-else-if="storeOptions.length"
            v-model="option"
            label="Tienda"
            mode="search"
            placeholder="Selecciona una tienda"
            :disabled="!enabled"
            class="w-full max-w-full"
            @change="onInput"
        />
        <span v-else> No se encontraron tiendas </span>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "StoresSearch",
    components: {
        CustomSimpleSelect
    },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: [String, Number],
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        stores: [],
        isLoading: true
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        storeOptions() {
            return this.stores.map((store) => ({
                label: store.name,
                value: store.id
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
        this.loadStores();
    },
    methods: {
        ...mapActions("stores", ["listStoresPaginated"]),
        async loadStores() {
            this.isLoading = true;
            try {
                const { items } = await this.listStoresPaginated({
                    itemsByPage: 100,
                    page: 1
                });
                this.stores = items;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        setInput(value) {
            this.option = value ?? "";
        },
        onInput() {
            this.$emit("change", this.option);
        }
    }
};
</script>
